module.exports = __webpack_public_path__ + "media/images/badge-fullcolor-alpha-0ff7c3e9c26e61a3247ba24d147010ab.png";